import { ModalButtons } from "@v2/components/overlay/ModalButtons/ModalButtons";
import { cn } from "@gettactic/helpers";

export const WPRequestFilterBottomModalButtons = ({
  handleClear,
  handleApply,
  className
}: {
  handleClear?: () => void;
  handleApply?: () => void;
  className?: string;
}) => {
  return (
    <div
      className={cn(
        "flex h-[44px] w-full select-none items-center border-t border-t-neutral-100",
        className
      )}
    >
      <ModalButtons onApply={handleApply} onCancel={handleClear} />
    </div>
  );
};
